import './styles.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Navigation,
  Pagination,
  A11y,
  Autoplay,
  Keyboard,
} from 'swiper/modules';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import austriaFlagIcon from '../../../assets/img/at.svg';
import swissFlagIcon from '../../../assets/img/ch.svg';
import brazilFlagIcon from '../../../assets/img/br.svg';
import team1 from '../../../assets/img/team1.webp';
import team2 from '../../../assets/img/team2.webp';
import team3 from '../../../assets/img/team3.webp';
import team4 from '../../../assets/img/team4.webp';
import team6 from '../../../assets/img/team6.webp';

const TeamSection = () => {
  const { t } = useTranslation();
  const teamMembers = [
    {
      name: 'DANIEL HEFTI',
      role: 'Chief Executive Officer',
      country: 'Switzerland',
      flagIcon: swissFlagIcon,
      photoUrl: team1,
      linkedinUrl: 'https://www.linkedin.com/in/daniel-hefti-8156a3299/',
    },
    {
      name: 'IGOR ARAÚJO',
      role: 'IT Manager & Full-Stack Development (Brazil Team)',
      country: 'Brazil',
      flagIcon: brazilFlagIcon,
      photoUrl: team2,
      linkedinUrl: 'https://www.linkedin.com/in/igorgabriel-dev/',
    },
    {
      name: 'MARIA VICTÓRIA',
      role: 'IT Manager & Frontend Developer (Brazil Team)',
      country: 'Brazil',
      flagIcon: brazilFlagIcon,
      photoUrl: team3,
      linkedinUrl: 'https://www.linkedin.com/in/vihhllopes/',
    },
    {
      name: 'MATHEUS LUIZ',
      role: 'Backend Development & DevOps',
      country: 'Brazil',
      flagIcon: brazilFlagIcon,
      photoUrl: team4,
      linkedinUrl: 'https://www.linkedin.com/in/matheus-luiz-001334201/',
    },
    {
      name: 'LARYSSA SAMS',
      role: 'Kundenbetreuerin',
      country: 'Austria',
      flagIcon: austriaFlagIcon,
      photoUrl: team6,
      linkedinUrl: 'https://www.linkedin.com/in/aida-cardoso-091620257/',
    },
  ];

  return (
    <section className="team-section">
      <div className="team-container">
        <h2>
          {t('home.team_text1')} <span>{t('home.team_text2')}</span>
        </h2>
        <Swiper
          modules={[Navigation, Pagination, A11y, Autoplay, Keyboard]}
          navigation
          keyboard={{ enabled: true }}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          speed={600}
          loop={true}
          slidesPerGroup={1}
          grabCursor
          centeredSlides
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 10 },
            640: { slidesPerView: 2, spaceBetween: 18 },
            1024: { slidesPerView: 5, spaceBetween: 24 },
          }}
          className="team-swiper"
        >
          {teamMembers.concat(teamMembers).map((member, index) => (
            <SwiperSlide key={index}>
              <div className="team-member-card">
                <div className="team-member-photo">
                  <img
                    src={member.photoUrl}
                    alt={`Photo of ${member.name}`}
                    className="member-photo-img"
                    fetchPriority="low"
                    decoding="async"
                    loading="lazy"
                  />
                  <h3>{member.name}</h3>
                </div>
                <div className="member-info">
                  <div className="member-location">
                    <img
                      src={member.flagIcon}
                      alt={`${member.country} Flag`}
                      className="flag-icon"
                      fetchPriority="low"
                      decoding="async"
                      loading="lazy"
                    />
                    <span>{member.country}</span>
                  </div>
                  <p className="member-role">{member.role}</p>

                  <a
                    href={member.linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkedin-link"
                    aria-label={t('home.linkedin_link_label', {
                      name: member.name,
                    })}
                  >
                    {t('home.linkedin_link_text')}
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TeamSection;
